import { createContext, useContext, type ReactNode } from 'react';

const ModalInlineContext = createContext<boolean | undefined>(undefined);
export const useModalInliner = () => useContext(ModalInlineContext);

interface ModalInlinerProps {
    children?: ReactNode;
}

export function ModalInliner({ children }: ModalInlinerProps) {
    return <ModalInlineContext.Provider value={true}>{children}</ModalInlineContext.Provider>;
}
